import { ClickEvent, Dialog, Layout } from "@mcleod/components";
import { AutogenLayoutDistanceRateTableDimensionPrompt } from "./autogen/AutogenLayoutDistanceRateTableDimensionPrompt";
import { CommonDialogs } from "@mcleod/common";

export class DistanceRateTableDimensionPrompt extends AutogenLayoutDistanceRateTableDimensionPrompt {
    static showModal(okClicked: (layout: DistanceRateTableDimensionPrompt) => void): Promise<Dialog> {
        const layout = Layout.getLayout("lme/powerbroker/DistanceRateTableDimensionPrompt") as DistanceRateTableDimensionPrompt;
        return CommonDialogs.showDialog(layout, {
            title: "Create Table",
            panelTitleProps: { backgroundColor: "primary.darker", color: "primary.reverse" },
            okProps: { onClick: async (event: ClickEvent) => okClicked(layout) },
        });
    }
}